import { aboutPoints, siteCredo } from '@/mocks/gua88-site';
import { SectionHead } from './articleUi';

export default function About() {
  return (
    <section id="about" className="border-b border-background-200 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionHead
          kicker="About · 关于本站"
          title="蹲后续，也要蹲得有分寸"
          desc="88吃瓜后续专区是一个面向吃瓜网友的娱乐热点事件持续追踪站。我们不做标题党，只想把「后续」讲清楚、讲可信。"
        />

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1.1fr_0.9fr]">
          {/* feature cards */}
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
            {aboutPoints.map((p) => (
              <div
                key={p.title}
                className="rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-primary-100 text-xl text-primary-700">
                  <i className={p.icon}></i>
                </span>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{p.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
              </div>
            ))}
          </div>

          {/* positioning + credo */}
          <div className="flex flex-col gap-5">
            <div className="rounded-lg bg-background-50 p-6">
              <p className="font-display text-sm uppercase tracking-[0.2em] text-accent-500">Our Stand</p>
              <h3 className="mt-2 font-heading text-lg font-black text-foreground-950">我们的内容立场</h3>
              <ul className="mt-4 space-y-3">
                {siteCredo.map((c, i) => (
                  <li key={i} className="flex gap-3">
                    <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent-100 text-[11px] font-bold text-accent-900">
                      {i + 1}
                    </span>
                    <p className="text-sm leading-relaxed text-foreground-700">{c}</p>
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-lg bg-primary-600 p-6">
              <h3 className="font-heading text-lg font-black text-background-50">联系我们 / 投稿报料</h3>
              <p className="mt-2 text-sm leading-relaxed text-background-100">
                若你有关于 88 事件的新线索、发现信息有误，或希望就相关内容与我们沟通，欢迎来信。
              </p>
              <a
                href="mailto:guanzhu@gua88.readdy.site"
                className="mt-4 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-4 py-2 text-sm font-medium text-primary-700 transition-colors hover:bg-accent-100"
              >
                <i className="ri-mail-send-line"></i>
                guanzhu@gua88.readdy.site
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}